module.exports = __webpack_public_path__ + "img/icon_star.b9d9fd0a.svg";